/**
 * Calendar popups open to the right of their cell. On a narrow screen (the POS iPad WebView)
 * the right-most staff columns leave no room, so the popup would be cut off by the screen edge.
 * These helpers decide when to flip such a popup to the left side of the cell instead.
 */

/**
 * `anchorLeft`: true when the popup's left edge starts at the anchor's left edge (a zero-width
 * anchor), false when it starts at the anchor's right edge.
 */
export const shouldFlipPopupLeft = (
  anchor: HTMLElement | null | undefined,
  popupWidth: number,
  gap = 0,
  anchorLeft = false,
) => {
  const rect = anchor?.getBoundingClientRect();
  if (!rect) return false;
  return (anchorLeft ? rect.left : rect.right) + gap + popupWidth > window.innerWidth;
};
